import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const authTokenGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.currentUserValue?.token || authService.getToken();

  if (!token) {
    console.log('No token found');
    return router.parseUrl('/authentication/signin');
  }

  if (authService.isTokenExpired()) {
    authService.logout();
    console.log('Token expired');
    return router.parseUrl('/authentication/signin');
  }

  return true;
};
